import { renderSlot as _renderSlot, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/app/ui/assets/svg/ics_o_close.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-681e2269")

_pushScopeId("data-v-681e2269")
const _hoisted_1 = { class: "alert" }
const _hoisted_2 = {
  ref: "sheetContents",
  class: "contents"
}
const _hoisted_3 = { class: "controls" }
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "draggable-thumb" }, null, -1)
const _hoisted_5 = {
  key: 0,
  ref: "titleHeader",
  class: "header"
}
const _hoisted_6 = { class: "header-body" }
const _hoisted_7 = { class: "title" }
const _hoisted_8 = {
  ref: "body",
  class: "body"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("section", null, [
    _createVNode("div", {
      id: "sheet",
      ref: "sheet",
      class: "sheet",
      "aria-hidden": !_ctx.modelValue,
      role: "dialog"
    }, [
      _createVNode("div", _hoisted_1, [
        _renderSlot(_ctx.$slots, "alert", {}, undefined, true)
      ]),
      _createVNode("div", {
        class: "overlay",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('update:modelValue', false)))
      }),
      _createVNode("div", _hoisted_2, [
        _createVNode("header", _hoisted_3, [
          _createVNode("div", {
            ref: "draggableArea",
            class: "draggable-area",
            onMousedown: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onDragStart && _ctx.onDragStart(...args))),
            onTouchstart: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onDragStart && _ctx.onDragStart(...args)))
          }, [
            _hoisted_4
          ], 544),
          (_ctx.title)
            ? (_openBlock(), _createBlock("header", _hoisted_5, [
                _createVNode("div", _hoisted_6, [
                  _createVNode("div", null, [
                    _createVNode("h2", _hoisted_7, _toDisplayString(_ctx.title), 1)
                  ]),
                  (_ctx.isUsingReset)
                    ? (_openBlock(), _createBlock("div", {
                        key: 0,
                        class: ["font-montserrat font-semibold text-14px", { 'text-red-lp-100': _ctx.isReset, 'text-red-lp-1800': !_ctx.isReset }],
                        onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.resetFilter && _ctx.resetFilter(...args)))
                      }, " Reset ", 2))
                    : (_openBlock(), _createBlock("img", {
                        key: 1,
                        src: _imports_0,
                        alt: "close-icon",
                        onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('update:modelValue', false)))
                      }))
                ])
              ], 512))
            : _createCommentVNode("", true)
        ]),
        _createVNode("main", _hoisted_8, [
          _renderSlot(_ctx.$slots, "default", {}, undefined, true)
        ], 512)
      ], 512)
    ], 8, ["aria-hidden"])
  ]))
})